import { TabsProps } from 'antd';

import Tabs from '@/components/shared/Tabs';
import { useAppSelector } from '@/hooks/redux';
import styled, { StyledProp, css } from '@/styled';

import CommentsTabs from './CommentsTabs';
import ContactTab from './ContactTab';
import ModulesTab from './ModulesTab';

interface CourseTabsProps extends StyledProp, TabsProps {
  enabled_talk_to_producer?: boolean;
  disable_comments: boolean;
}

const CourseTabs = (props: CourseTabsProps) => {
  const user = useAppSelector(state => state.auth.user);
  const tabs = ['Módulos'];

  if (user) {
    if (!props.disable_comments) tabs.push('Meus Comentários');
    if (props.enabled_talk_to_producer) tabs.push('Fale com o Produtor');
  }

  return (
    <Tabs
      className={props.className}
      items={
        tabs.map((label, key) => ({
          label,
          key: String(key),
          // eslint-disable-next-line react/jsx-key
          children: [<ModulesTab />, <CommentsTabs />, <ContactTab />][key]
        })) as TabsProps['items']
      }
    />
  );
};

export default styled(CourseTabs)`
  ${({ theme }) => {
    return css`
      .ant-tabs-tabpane {
        background: ${theme.variables.tabs.contentBackground};

        ${theme.breakpoints.down('lg')} {
          padding: ${theme.space.spacing(6, 4)};
        }
      }
    `;
  }}
`;
